import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DragescentState } from "../../../../store/reducers/stateType";
import SubMenu from "../../../Menu/SubMenu";
import { buyItem, finishQuest, sellItem } from "../../../../store/actions";
import { RESOURCE_IDS } from "../../../../lib/enums";
import { Quest } from "../../../../lib/types";

const AllianceStorage = () => {
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const marketItems = useSelector((state: DragescentState) => state.governorate.marketItems);
  const resources = useSelector((state: DragescentState) => state.governorate.resources);
  const marketLimit = useSelector((state: DragescentState) => state.governorate.marketLimit);
  const marketUsage = useSelector((state: DragescentState) => state.governorate.marketUsage);
  const availableQuests = useSelector(
    (state: DragescentState) => state.governorate.availableQuests
  );
  const finishedQuests = useSelector((state: DragescentState) => state.governorate.finishedQuests);
  const dispatch = useDispatch();

  const [focused, setFocused] = useState<string | null>(null)
  const [amount, setAmount] = useState<number>(0);
  const [takeAmount, setTakeAmount] = useState<number>(0);
  const [marketLimitReached, setMarketLimitReached] = useState<boolean>(marketUsage >= marketLimit);

  const changeAmount = (newAmount: string, resourceName: string) => {
    if (marketLimitReached) {
      return;
    }

    const validatedAmount = Number.isNaN(parseInt(newAmount, 10))
      ? 0
      : Math.min(parseInt(newAmount, 10), resources[resourceName], marketLimit - marketUsage);
    setAmount(validatedAmount);
  }

  const changeTakeAmount = (newAmount: string, resourceName: string, storage: number) => {
    if (marketLimitReached) {
      return;
    }

    const validatedAmount = Number.isNaN(parseInt(newAmount, 10))
      ? 0
      : Math.min(parseInt(newAmount, 10), storage, marketLimit - marketUsage);
    setTakeAmount(validatedAmount);
  }

  const handleStorageTake = (itemId: number, resourceName: string) => {
    if (focused && focused === resourceName && takeAmount) {
      dispatch(buyItem(itemId, takeAmount));
      setTakeAmount(0)
    }
  }

  useEffect(() => {
    if (availableQuests?.some((q: Quest) => q.id === 19)
      && !finishedQuests?.some((q: Quest) => q.id === 19)) {
      dispatch(finishQuest(19));
    }
  }, [])

  useEffect(() => {
    setMarketLimitReached(marketUsage >= marketLimit);
  }, [marketUsage])

  return <>
    <SubMenu
      tabs={[
        {
          name: "AllianceStorage",
          title: "Storage",
          icon: "trziste",
          label: "Alliance Storage",
          active: true
        },
        {
          name: "Marketplace",
          title: "Marketplace",
          icon: "trziste",
          label: "World Market",
          active: false
        }
      ]}
    />

    {!alliance ? <section className="boxes-group">
      <span className="divider"/>
      <div className="box">
        <span className={"text-info"}>Only governorates in alliance can use Alliance storage</span>
      </div>
      <span className="divider"/>
    </section>
      : <>
    <section className="boxes-group">
      <h2 className="h2 h2-first">
        <span className="bordered">Fill</span>
      </h2>
      <span className="divider"/>
      <div className="box">
        <p className={`text-bigger ${marketLimitReached ? "negative" : ""}`}>Market limit {marketUsage}/{marketLimit}</p>
        <div className="row persons market-items">
          {marketItems.reserves.map((item: any) => {
            const resourceName = item.id.split("-")[1];
            return (<div className="col-sm-4 col-md-2" style={{ width: "14.285714%" }}>
              <div
                className={`person ${!item || !resources[resourceName] || !Number.parseInt(resources[resourceName], 10)
                || marketLimitReached ? "disabled" : ""} no-min-height`}
              >
              <span className="white">
                {resources[resourceName] || 0}
              </span> <i className={`icon icon-standalone icon-sm icon-${item.resource.icon} middle`}/><br/>
              <div>
                <input
                  type="tel"
                  className="input"
                  onChange={event => changeAmount(event.target.value, resourceName)}
                  value={focused === resourceName ? amount : 0}
                  style={{ display: "inline-block", maxWidth: "50px" }}
                  onFocus={() => {
                    setAmount(0);
                    setTakeAmount(0);
                    setFocused(resourceName);
                  }}
                />
              </div>
                <a
                  className={`btn btn-sm btn-blank ${focused === resourceName && amount && !marketLimitReached
                    ? "" : "disabled"}`}
                  onClick={() => focused && focused === resourceName && amount
                    && dispatch(sellItem(RESOURCE_IDS[focused], amount, "alliance")) && setAmount(0)
                  }
                >
                  Fill
                </a>
              </div>
            </div>)
          })}
        </div>
      </div>
    </section>

    <section className="boxes-group">
      <h2 className="h2">
        <span className="bordered">Take</span>
      </h2>
      <span className="divider"/>
      <div className="box">
        <div className="row persons market-items">
          {marketItems.reserves.map((item: any) => {
            const resourceName = item.id.split("-")[1];
            return (<div className="col-sm-4 col-md-2" style={{ width: "14.285714%" }} >
              <div
                className={`person ${!item || !item.storage || marketLimitReached ? "disabled" : ""} no-min-height`}
              >
              <span className="white">
                <b>{item.storage}</b>
              </span> <i className={`icon icon-standalone icon-sm icon-${item.resource.icon} middle`}/><br/>
                <div>
                  <input
                    type="tel"
                    className="input"
                    onChange={event => changeTakeAmount(
                      event.target.value, resourceName, item.storage
                    )}
                    value={focused === resourceName ? takeAmount : 0}
                    style={{ display: "inline-block", maxWidth: "50px" }}
                    onFocus={() => {
                      setAmount(0);
                      setTakeAmount(0);
                      setFocused(resourceName);
                    }}
                  />
                </div>
                <a
                  className={`btn btn-sm btn-blank ${focused === resourceName && takeAmount && !marketLimitReached
                    ? "" : "disabled"}`}
                  onClick={() => handleStorageTake(item.id, resourceName)}
                >
                  Take
                </a>
              </div>
            </div>)
          })}
        </div>
      </div>
    </section>
      </>}
  </>
}

export default AllianceStorage;
